// shell/OnboardingRedirect.tsx — sends a brand-new, email-verified member to the
// first-run "Welcome" flow (1.24.00 B1). Mounted in BOTH ShellLayout branches
// next to VerifyEmailBanner; renders nothing for everyone else.
//
// The whole rule lives in features/onboarding/onboardingGate.ts
// (shouldRedirectToOnboarding) — STRICT `onboardedAt === null`, verified only,
// and not deferred for this tab. Read that file before touching this one.
import { Navigate } from 'react-router-dom';
import { useSession } from '@/hooks';
import { shouldRedirectToOnboarding } from '@/features/onboarding/onboardingGate';

export function OnboardingRedirect() {
  const { currentUser, isAuthenticated, isEmailVerified } = useSession();
  if (!shouldRedirectToOnboarding(currentUser, isAuthenticated, isEmailVerified)) return null;
  return <Navigate to="/onboarding" replace />;
}
